import { render, staticRenderFns } from "./JSelectGoyinshang.vue?vue&type=template&id=b628922e&scoped=true"
import script from "./JSelectGoyinshang.vue?vue&type=script&lang=js"
export * from "./JSelectGoyinshang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b628922e",
  null
  
)

export default component.exports